export default __webpack_public_path__ + "static/24-d635d292a18fb0266426294c7871f5ce.jpg";